import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InfoDrugRoutingModule } from './info-drug-routing.module';
import { InfoDrugComponent } from './info-drug.component';
import { ButtonModule, BzFAQModule, BzHelpCenterModule, BzProductModule, ReturnBtnArrowModule } from '../../modules-ui';
import { SharedModule } from '@shared';
import { TranslocoModule } from '@ngneat/transloco';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { RouterModule } from '@angular/router';
import { StaticFooterModule } from 'src/app/modules-ui/layouts';
import { BzInstructionAuthorModule } from 'src/app/modules-ui/blocks-ui/bz-instruction-editor/bz-instruction-author.module';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { InfoDragTablePermissionComponent } from './table/info-drag-table-permission/info-drag-table-permission.component';
import { InfoDragTableInfoComponent } from './table/info-drag-table-info/info-drag-table-info.component';
import { InfoDragPictureComponent } from './info-drag-picture/info-drag-picture.component';

@NgModule({
  declarations: [
    InfoDrugComponent,
    InfoDragTableInfoComponent,
    InfoDragTablePermissionComponent,
    InfoDragPictureComponent
  ],
    imports: [
        CommonModule,
        InfoDrugRoutingModule,
        ButtonModule,
        BzProductModule,
        ReturnBtnArrowModule,
        SharedModule,
        TranslocoModule,
        ShareButtonsModule,
        ShareIconsModule,
        RouterModule,
        StaticFooterModule,
        BzHelpCenterModule,
        BzFAQModule,
        BzInstructionAuthorModule
    ]
})
export class InfoDrugModule { }
